import { useContext } from "react";
import { FirebaseContext } from "../../../../pages/FirebaseProvider";

const CLONE_CICO_FUNCTION_NAME = "cloneCICO";

export const useCloneCICO = () => {
  const firebase = useContext(FirebaseContext);

  if (!firebase) {
    return undefined;
  }

  const cloneCICO = firebase.functions.httpsCallable(CLONE_CICO_FUNCTION_NAME);
  const dataOwner = firebase.auth.currentUser.uid;

  return (id: string, newId?: string): Promise => {
    const params = newId ? { id, dataOwner, newId } : { id, dataOwner };
    return cloneCICO(params).then(({ data }) => data);
  };
};
